export default __webpack_public_path__ + "static/media/5.8edd7953.png";